import { Button, RegularModal } from '@/ui-kit';

interface LogoutModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: React.MouseEventHandler<HTMLButtonElement>;
}

export const LogoutModal: React.FC<LogoutModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
}) => {
  return (
    <RegularModal
      size="small"
      onClose={onCancel}
      isOpen={isOpen}
      id="logoutModal"
      title="Are you sure you want to logout?"
      buttons={{
        variant: 'double',
        list: [
          <Button
            variant="primary"
            size="regular"
            kind="default"
            onClick={onConfirm}
          >
            Logout
          </Button>,
          <Button
            variant="tertiary"
            size="regular"
            kind="danger"
            onClick={onCancel}
          >
            Cancel
          </Button>,
        ],
      }}
    />
  );
};
